export default __webpack_public_path__ + "static/media/tickIcon.19b2829f.svg";